import type React from "react";

import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { MUITextInput } from "shared/atoms/inputs/MUITextInput";
import { getSectionTitleKey } from "utils/medicalNotes";

import { Section } from ".";

interface Props {
  readonly?: boolean;
  visible?: boolean;
  onChange?: (value: string) => void;
}

const ExclusionSection: React.FC<Props> = ({ readonly = false, visible = false, onChange }) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext();

  return visible ? (
    <Section
      // FIXME: type translation
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      label={t(getSectionTitleKey("exclusion"))}
      disabled={readonly}
      dataTestId="exclusion-section"
      backgroundColor="blue"
    >
      <Typography variant="subtitle1" color="textSecondary" mb={1}>
        {t("patients.notes.exclusion.reason_description")}
      </Typography>
      <MUITextInput
        error={errors?.exclusion_reason ? t("errors.string.empty") : undefined}
        name="structured_fields.exclusion_reason"
        disabled={readonly}
        label={t("patients.notes.exclusion.reason_title")}
        multiline
        onUpdate={onChange}
      />
      <Typography variant="subtitle1" color="textSecondary" mt={0.5}>
        {t("patients.notes.exclusion.not_saved")}
      </Typography>
    </Section>
  ) : null;
};

export { ExclusionSection };
